var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-ad-view"},[_c('div',{staticClass:"home-ad-group"},[(_vm.AdInfo)?_c('div',[_c('van-image',{staticClass:"home-ad-img",attrs:{"src":_vm.AdInfo.AdImg},on:{"click":_vm.toAd}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }